var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeIntelligence500Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 223.209,
    height: 200.152,
    viewBox: "0 0 142.303 112.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2699fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c2d7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32423",
    "data-name": "Group 32423",
    transform: "translate(-2585.381 -451.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(2585.381 451.544)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop_mac-24px",
    transform: "translate(13.131 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M0,0H108.715V108.715H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7262",
    "data-name": "Rectangle 7262",
    width: 81.895,
    height: 45.725,
    transform: "translate(13.485 17.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M91.6,2H10.06A9.086,9.086,0,0,0,1,11.06V65.417a9.086,9.086,0,0,0,9.06,9.06H41.768l-9.06,13.589V92.6H68.947v-4.53l-9.06-13.589H91.6a9.086,9.086,0,0,0,9.06-9.06V11.06A9.086,9.086,0,0,0,91.6,2Zm0,54.357H10.06V11.06H91.6Z",
    transform: "translate(3.53 7.06)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "laptop_mac-24px",
    transform: "translate(0 41.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M0,0H70.9V70.9H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7261",
    "data-name": "Rectangle 7261",
    width: 48.455,
    height: 32.758,
    transform: "translate(11.602 14.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M59.084,47.313A5.9,5.9,0,0,0,64.963,41.4l.03-32.5A5.926,5.926,0,0,0,59.084,3H11.817A5.926,5.926,0,0,0,5.908,8.908V41.4a5.926,5.926,0,0,0,5.908,5.908H0a5.926,5.926,0,0,0,5.908,5.908H64.992A5.926,5.926,0,0,0,70.9,47.313ZM11.817,8.908H59.084V41.4H11.817ZM35.45,50.267A2.954,2.954,0,1,1,38.4,47.313,2.963,2.963,0,0,1,35.45,50.267Z",
    transform: "translate(0 5.863)",
    fill: "#3758fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bug_report-24px",
    transform: "translate(2675.824 497.778) rotate(-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17147",
    "data-name": "Path 17147",
    d: "M0,0H16.379V16.379H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17148",
    "data-name": "Path 17148",
    d: "M10.919,3.412H9A4.084,4.084,0,0,0,7.76,2.075L8.872.962,7.91,0,6.429,1.481a4.139,4.139,0,0,0-.969-.116,4.039,4.039,0,0,0-.962.116L3.01,0,2.047.962,3.153,2.075A4.137,4.137,0,0,0,1.918,3.412H0V4.777H1.426a4.53,4.53,0,0,0-.061.682v.682H0V7.507H1.365V8.19a4.53,4.53,0,0,0,.061.682H0v1.365H1.918a4.088,4.088,0,0,0,7.084,0h1.918V8.872H9.493a4.53,4.53,0,0,0,.061-.682V7.507h1.365V6.142H9.554V5.46a4.53,4.53,0,0,0-.061-.682h1.426ZM6.825,8.872H4.095V7.507h2.73Zm0-2.73H4.095V4.777h2.73Z",
    transform: "translate(2.73 2.047)",
    fill: "#c90f0f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bug_report-24px-2",
    "data-name": "bug_report-24px",
    transform: "matrix(-0.588, -0.809, 0.809, -0.588, 2635.758, 492.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17147-2",
    "data-name": "Path 17147",
    d: "M0,0H16.379V16.379H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17148-2",
    "data-name": "Path 17148",
    d: "M10.919,3.412H9A4.084,4.084,0,0,0,7.76,2.075L8.872.962,7.91,0,6.429,1.481a4.139,4.139,0,0,0-.969-.116,4.039,4.039,0,0,0-.962.116L3.01,0,2.047.962,3.153,2.075A4.137,4.137,0,0,0,1.918,3.412H0V4.777H1.426a4.53,4.53,0,0,0-.061.682v.682H0V7.507H1.365V8.19a4.53,4.53,0,0,0,.061.682H0v1.365H1.918a4.088,4.088,0,0,0,7.084,0h1.918V8.872H9.493a4.53,4.53,0,0,0,.061-.682V7.507h1.365V6.142H9.554V5.46a4.53,4.53,0,0,0-.061-.682h1.426ZM6.825,8.872H4.095V7.507h2.73Zm0-2.73H4.095V4.777h2.73Z",
    transform: "translate(2.73 2.047)",
    fill: "#c90f0f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bug_report-24px-3",
    "data-name": "bug_report-24px",
    transform: "translate(2618.203 522.7) rotate(158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17147-3",
    "data-name": "Path 17147",
    d: "M0,0H16.379V16.379H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17148-3",
    "data-name": "Path 17148",
    d: "M10.919,3.412H9A4.084,4.084,0,0,0,7.76,2.075L8.872.962,7.91,0,6.429,1.481a4.139,4.139,0,0,0-.969-.116,4.039,4.039,0,0,0-.962.116L3.01,0,2.047.962,3.153,2.075A4.137,4.137,0,0,0,1.918,3.412H0V4.777H1.426a4.53,4.53,0,0,0-.061.682v.682H0V7.507H1.365V8.19a4.53,4.53,0,0,0,.061.682H0v1.365H1.918a4.088,4.088,0,0,0,7.084,0h1.918V8.872H9.493a4.53,4.53,0,0,0,.061-.682V7.507h1.365V6.142H9.554V5.46a4.53,4.53,0,0,0-.061-.682h1.426ZM6.825,8.872H4.095V7.507h2.73Zm0-2.73H4.095V4.777h2.73Z",
    transform: "translate(2.73 2.047)",
    fill: "#c90f0f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17149",
    "data-name": "Path 17149",
    d: "M4025.361-3867.848c-.2-1.85-15.342-12.03-17.319-23.747s-16.966-17.215-16.966-17.215",
    transform: "translate(-1298.174 4413.466)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    strokeDasharray: 5,
    opacity: 0.179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17150",
    "data-name": "Path 17150",
    d: "M3955.328-3936.331s-11.141,6.961-14.385-4.091-5.487-21.489-17.524-13.955",
    transform: "translate(-1276.692 4428.748)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    strokeDasharray: 5,
    opacity: 0.179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17151",
    "data-name": "Path 17151",
    d: "M3884.042-3939.114s-14.23,11.551-23.617,7.666-4.433-12.45,0-11.472,5.725,8.632,1.283,27.75",
    transform: "translate(-1254.993 4424.321)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    strokeDasharray: 5,
    opacity: 0.179
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIntelligence500Icon);
export default __webpack_public_path__ + "static/media/TimeIntelligence_500_Icon.9e4db07afdbdec79e98044d9c7d5721f.svg";
export { ForwardRef as ReactComponent };